
import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getDoctorLoanById, getAllAdmins } from "../../../middleware/backend_hepler";
import { AuthContext } from "../../../Context/AuthContext";
import { FaEdit } from 'react-icons/fa';
import { Row, Col, Button } from "react-bootstrap";
import PdfDownloader from "../../../common/PdfDownloader";


const EditDoctorViewModal = ({ isOpen, onClose, loanId }) => {
  const { adminId, adminName, adminRole } = useContext(AuthContext);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    form_id: "",
    created_id: "",
    created_by: "",
    assigned_to: "",
    status: "",
    rejected_reason: "",
    name: "",
    dob: "",
    age: "",
    mobile: "",
    email: "",
    father_name: "",
    mother_name: "",
    marital_status: "",
    spouse_name: "",
    residence_type: "",
    address: "",
    landmark: "",
    state: "",
    city: "",
    pincode: "",
    current_address_as_per_aadhar: "",
    present_address: "",
    present_state: "",
    present_city: "",
    present_pincode: "",
    required_loan_amount: "",
    existing_emi_amount: "",
    degree: "",
    service_experience: "",
    mbbs_completed_year: "",
    degree_others: "",
    work_type: "",
    clinic_name: "",
    clinic_address: "",
    clinic_state: "",
    clinic_city: "",
    clinic_pincode: "",
    hospital_name: "",
    total_experience: "",
    net_salary: "",
    is_pf_deducted: "",
    hospital_address: "",
    hospital_state: "",
    hospital_city: "",
    hospital_pincode: "",
    add_reference: "",
    reference_name: "",
    reference_mobile: "",
    reference_address: "",
    reference_location: "",
    bank_name: "",
    pan_card: null,
    aadhar_card: null,
    photo: null,
    payslip: null,
    salaried_account_statement: null,
    itr: null,
    degree_certificate: null,
    others: null,
    ima_certificate: null,
    clinic_registration_certificate: null,
  });

  useEffect(() => {
    const fetchAgents = async () => {
      if (loanId && isOpen) {
        try {
          const response = await getAllAdmins();
          const filteredAgents = response.filter((admin) => admin.role === "employee");
          setAgents(filteredAgents);
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.error("Error fetching agents:", error);
        }
      }
    };

    fetchAgents();
  }, []);

  useEffect(() => {
    const fetchLoanData = async () => {
      try {
        const loan = await getDoctorLoanById(loanId);
        setFormData({
          form_id: loan.form_id || "",
          created_id: loan.created_id || "",
          created_by: loan.created_by || "",
          assigned_to: loan.assigned_to || "",
          status: loan.status || "",
          rejected_reason: loan.rejected_reason || "",
          name: loan.name || "",
          dob: loan.dob || "",
          age: loan.age || "",
          mobile: loan.mobile || "",
          email: loan.email || "",
          father_name: loan.father_name || "",
          mother_name: loan.mother_name || "",
          marital_status: loan.marital_status || "",
          spouse_name: loan.spouse_name || "",
          residence_type: loan.residence_type || "",
          address: loan.address || "",
          landmark: loan.landmark || "",
          state: loan.state || "",
          city: loan.city || "",
          pincode: loan.pincode || "",
          current_address_as_per_aadhar: loan.current_address_as_per_aadhar || "",
          present_address: loan.present_address || "",
          present_state: loan.present_state || "",
          present_city: loan.present_city || "",
          present_pincode: loan.present_pincode || "",
          required_loan_amount: loan.required_loan_amount || "",
          existing_emi_amount: loan.existing_emi_amount || "",
          degree: loan.degree || "",
          service_experience: loan.service_experience || "",
          mbbs_completed_year: loan.mbbs_completed_year || "",
          degree_others: loan.degree_others || "",
          work_type: loan.work_type || "",
          clinic_name: loan.clinic_name || "",
          clinic_address: loan.clinic_address || "",
          clinic_state: loan.clinic_state || "",
          clinic_city: loan.clinic_city || "",
          clinic_pincode: loan.clinic_pincode || "",
          hospital_name: loan.hospital_name || "",
          total_experience: loan.total_experience || "",
          net_salary: loan.net_salary || "",
          is_pf_deducted: loan.is_pf_deducted || "",
          hospital_address: loan.hospital_address || "",
          hospital_state: loan.hospital_state || "",
          hospital_city: loan.hospital_city || "",
          hospital_pincode: loan.hospital_pincode || "",
          add_reference: loan.add_reference || "",
          reference_name: loan.reference_name || "",
          reference_mobile: loan.reference_mobile || "",
          reference_address: loan.reference_address || "",
          reference_location: loan.reference_location || "",
          bank_name: loan.bank_name || "",
          pan_card: loan.pan_card || null,
          aadhar_card: loan.aadhar_card || null,
          photo: loan.photo || null,
          payslip: loan.payslip || null,
          salaried_account_statement: loan.salaried_account_statement || null,
          itr: loan.itr || null,
          degree_certificate: loan.degree_certificate || null,
          others: loan.others || null,
          ima_certificate: loan.ima_certificate || null,
          clinic_registration_certificate: loan.clinic_registration_certificate || null,
        });
      } catch (error) {
        console.error("Error fetching doctor loan data:", error);
      }
    };
    fetchLoanData();
  }, [loanId, adminId, adminName]);

  const filteredPdfFormData = [
    {
      title: "Personal Details",
      data: {
        "Loan ID": formData.form_id,
        "Agent ID": formData.created_id,
        "Agent By": formData.created_by,
        "Assign to": formData.assigned_to,
        "Lead Status": formData.status,
        ...(formData.status === "Rejected" && {
          "Rejected Reason": formData.rejected_reason,
        }),
        "Name": formData.name,
        "Dob": formData.dob,
        "Age": formData.age,
        "Mobile": formData.mobile,
        "Email ID": formData.email,
        "Father Name": formData.father_name,
        "Mother Name": formData.mother_name,
        "Marital Status": formData.marital_status,
        ...(formData.marital_status === "married" && {
          "Spouse Name": formData.spouse_name,
        }),
        "Residence Type": formData.residence_type,
        "Address": formData.address,
        "Landmark": formData.landmark,
        "State": formData.state,
        "City": formData.city,
        "Pincode": formData.pincode,
        "Current Address not as Per Aadhaar": formData.current_address_as_per_aadhar,
        ...(formData.current_address_as_per_aadhar === "No" && {
          "Address(Aadhaar)": formData.present_address,
          "State(Aadhaar)": formData.present_state,
          "City(Aadhaar)": formData.present_city,
          "Pincode(Aadhaar)": formData.present_pincode,
        }),
      },
    },
    {
      title: "Income Details",
      data: {
        "Required Loan Amount": formData.required_loan_amount,
        "Existing EMI": formData.existing_emi_amount,
        "Choose Degree": formData.degree,
        "Bank Name": formData.bank_name,
        ...(formData.degree === "MBBS" && {
          "Service Experience": formData.service_experience,
          "MBBS Completed Year": formData.mbbs_completed_year,
        }),
        ...(formData.degree === "Others" && {
          "Degree Others": formData.degree_others,
        }),
        "Work Type": formData.work_type,
        ...(formData.work_type === "Own Clinic" && {
          "Clinic Name": formData.clinic_name,
          "Clinic Address": formData.clinic_address,
          "Clinic State": formData.clinic_state,
          "Clinic City": formData.clinic_city,
          "Clinic Pincode": formData.clinic_pincode,
        }),
        ...(formData.work_type === "Salaried" && {
          "Working Hospital Name": formData.hospital_name,
          "Total Experience": formData.total_experience,
          "Net Salary": formData.net_salary,
          "Is PF Deducted": formData.is_pf_deducted,
          "Hospital Address": formData.hospital_address,
          "Hospital State": formData.hospital_state,
          "Hospital City": formData.hospital_city,
          "Hospital Pincode": formData.hospital_pincode,
        }),
      },
    },
    {
      title: "Reference Details",
      data: (formData.add_reference === "Relative" || formData.add_reference === "Colleague") ? {
        "Add Reference": formData.add_reference,
        "Name": formData.reference_name,
        "Mobile": formData.reference_mobile,
        "Address": formData.reference_address,
        "Location": formData.reference_location,
      } : {},
    },
  ];


  const handleEditClick = () => {
    navigate(`/edit-doctor-loan/${loanId}`);
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('modal-overlay-edit')) {
      onClose();
    }
  };

  const formattedDob = formData.dob
    ? (() => {
        const d = new Date(formData.dob);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      })()
    : "";

  if (!isOpen) return null;

  return (
    <div className="modal-overlay-edit" onClick={handleOverlayClick}>
      <div className="modal-content-edit">
      <h3 className="edit-title">
        <span className="product-title-text">Doctor Loan</span>
        <span className="action-icon">
          <FaEdit
            className="edit-loan"
            style={{ cursor: "pointer" }}
            onClick={handleEditClick}
          />
          <PdfDownloader formData={filteredPdfFormData} loanId={loanId} />
        </span>
      </h3>
        <div className="form-content-section">
          <div className="step-sections-personal-details-sections">
            <h4>Personal Details</h4>
            <div className="form-row-step">
              <strong>Loan ID:</strong>
              <div className="value">{formData.form_id}</div>
            </div>
            {adminRole !== "customer"&&(
              <>
                <div className="form-row-step">
                  <strong>Employee ID:</strong>
                  <div className="value">{formData.created_id}</div>
                </div>

                <div className="form-row-step">
                  <strong>Employee:</strong>
                  <div className="value">{formData.created_by}</div>
                </div>
              </>
            )}
            {(adminRole === "admin")&&(
              <div className="form-row-step">
                <strong>Assign to:</strong>
                <div className="value">{formData.assigned_to}</div>
              </div>
            )}

            <div className="form-row-step">
              <strong>Lead Status:</strong>
              <div className="value">{formData.status}</div>
            </div>

            {formData.status === "Rejected" && (
              <div className="form-row-step">
                <strong>Rejected reason:</strong>
                <div className="value">{formData.rejected_reason}</div>
              </div>
            )}

            <div className="form-row-step">
              <strong>Name:</strong>
              <div className="value">{formData.name}</div>
            </div>

            <div className="form-row-step">
              <strong>Dob:</strong>
              <div className="value">{formattedDob}</div>
            </div>

            <div className="form-row-step">
              <strong>age:</strong>
              <div className="value">{formData.age}</div>
            </div>

            <div className="form-row-step">
              <strong>Mobile:</strong>
              <div className="value">{formData.mobile}</div>
            </div>

            <div className="form-row-step">
              <strong>Email ID:</strong>
              <div className="value">{formData.email}</div>
            </div>

            <div className="form-row-step">
              <strong>Father Name:</strong>
              <div className="value">{formData.father_name}</div>
            </div>

            <div className="form-row-step">
              <strong>Mother Name:</strong>
              <div className="value">{formData.mother_name}</div>
            </div>

            <div className="form-row-step">
              <strong>Marital Status:</strong>
              <div className="value">{formData.marital_status}</div>
            </div>

            {formData.marital_status === "married" && (
              <div className="form-row-step">
                <strong>Spouse Name:</strong>
                <div className="value">{formData.spouse_name}</div>
              </div>
            )}

            <div className="form-row-step">
              <strong>Residence Type:</strong>
              <div className="value">{formData.residence_type}</div>
            </div>

            <div className="form-row-step">
              <strong>Address:</strong>
              <div className="value">{formData.address}</div>
            </div>

            <div className="form-row-step">
              <strong>Landmark:</strong>
              <div className="value">{formData.landmark}</div>
            </div>

            <div className="form-row-step">
              <strong>State:</strong>
              <div className="value">{formData.state}</div>
            </div>

            <div className="form-row-step">
              <strong>City:</strong>
              <div className="value">{formData.city}</div>
            </div>

            <div className="form-row-step">
              <strong>Pincode:</strong>
              <div className="value">{formData.pincode}</div>
            </div>

            <div className="form-row-step">
              <strong>Current Address not as Per Aadhaar:</strong>
              <div className="value">
                {formData.current_address_as_per_aadhar}
              </div>
            </div>

            {formData.current_address_as_per_aadhar === "No" && (
              <>
                <div className="form-row-step">
                  <strong>Present Aadhar Address:</strong>
                  <div className="value">{formData.present_address}</div>
                </div>

                <div className="form-row-step">
                  <strong>State:</strong>
                  <div className="value">{formData.present_state}</div>
                </div>

                <div className="form-row-step">
                  <strong>City:</strong>
                  <div className="value">{formData.present_city}</div>
                </div>

                <div className="form-row-step">
                  <strong>Pincode:</strong>
                  <div className="value">{formData.present_pincode}</div>
                </div>
              </>
            )}

            <h4>Income Details</h4>

            <div className="form-row-step">
              <strong>Required Loan Amount:</strong>
              <div className="value">{formData.required_loan_amount}</div>
            </div>

            <div className="form-row-step">
              <strong>Existing EMI:</strong>
              <div className="value">{formData.existing_emi_amount}</div>
            </div>

            <div className="form-row-step">
              <strong>Choose Degree:</strong>
              <div className="value">{formData.degree}</div>
            </div>

            {adminRole !== "customer" &&(
              <div className="form-row-step">
                <strong>Bank Name:</strong>
                <div className="value">{formData.bank_name}</div>
              </div>
            )}

            {formData.degree === "MBBS" && (
              <>
                <div className="form-row-step">
                  <strong>Service Experience:</strong>
                  <div className="value">{formData.service_experience}</div>
                </div>

                <div className="form-row-step">
                  <strong>MBBS Completed Year:</strong>
                  <div className="value">{formData.mbbs_completed_year}</div>
                </div>
              </>
            )}

            {formData.degree === "Others" && (
              <div className="form-row-step">
                <strong>Degree Others:</strong>
                <div className="value">{formData.degree_others}</div>
              </div>
            )}

            <div className="form-row-step">
              <strong>Work Type:</strong>
              <div className="value">{formData.work_type}</div>
            </div>

            {formData.work_type === "Own Clinic" && (
              <>
                <div className="form-row-step">
                  <strong>Clinic Name:</strong>
                  <div className="value">{formData.clinic_name}</div>
                </div>

                <div className="form-row-step">
                  <strong>Clinic Address:</strong>
                  <div className="value">{formData.clinic_address}</div>
                </div>

                <div className="form-row-step">
                  <strong>Clinic State:</strong>
                  <div className="value">{formData.clinic_state}</div>
                </div>

                <div className="form-row-step">
                  <strong>Clinic City:</strong>
                  <div className="value">{formData.clinic_city}</div>
                </div>

                <div className="form-row-step">
                  <strong>Clinic Pincode:</strong>
                  <div className="value">{formData.clinic_pincode}</div>
                </div>
              </>
            )}

            {formData.work_type === "Salaried" && (
              <>
                <div className="form-row-step">
                  <strong>Working Hospital Name:</strong>
                  <div className="value">{formData.hospital_name}</div>
                </div>

                <div className="form-row-step">
                  <strong>Total Experience:</strong>
                  <div className="value">{formData.total_experience}</div>
                </div>

                <div className="form-row-step">
                  <strong>Net Salary:</strong>
                  <div className="value">{formData.net_salary}</div>
                </div>

                <div className="form-row-step">
                  <strong>Is PF Deducted:</strong>
                  <div className="value">{formData.is_pf_deducted}</div>
                </div>

                <div className="form-row-step">
                  <strong>Hospital Address:</strong>
                  <div className="value">{formData.hospital_address}</div>
                </div>

                <div className="form-row-step">
                  <strong>Hospital State:</strong>
                  <div className="value">{formData.hospital_state}</div>
                </div>

                <div className="form-row-step">
                  <strong>Hospital City:</strong>
                  <div className="value">{formData.hospital_city}</div>
                </div>

                <div className="form-row-step">
                  <strong>Hospital Pincode:</strong>
                  <div className="value">{formData.hospital_pincode}</div>
                </div>
              </>
            )}
            {(formData.add_reference === "Relative" || formData.add_reference === "Colleague") && (
              <>
                <h4>Reference Details</h4>
                <div className="form-row-step">
                  <strong>Add Reference:</strong>
                  <div className="value">{formData.add_reference}</div>
                </div>

                <div className="form-row-step">
                  <strong>Name:</strong>
                  <div className="value">{formData.reference_name}</div>
                </div>

                <div className="form-row-step">
                  <strong>Mobile:</strong>
                  <div className="value">{formData.reference_mobile}</div>
                </div>

                <div className="form-row-step">
                  <strong>Address :</strong>
                  <div className="value">{formData.reference_address}</div>
                </div>

                <div className="form-row-step">
                  <strong>Location:</strong>
                  <div className="value">{formData.reference_location}</div>
                </div>
              </>
            )}
          </div>

          <div className="button-sections">
            <Row>
              <Col className="text-end">
                <Button
                  className="custom-back-button"
                  type="button"
                  onClick={onClose}
                >
                  Close
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditDoctorViewModal;